// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-stadium-house -> aion-management-stadium-house -> overlook-at-flanders
// Generated: 2026-10-22T20:06:22.708Z
// Counts: 1 design, 100 content, 66 slot group, 1 collection binding, 9 section, 4 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibility-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Accessibility</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiesforyou.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities Built For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>YOUR NEW HOME AWAITS</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Apply Now</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "contact-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>WE'RE HERE TO HELP</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Us</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Frequently asked questions</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>THE COMFORTS OF HOME</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>At Overlook at Flanders in scenic Mount Olive, NJ, we offer thoughtfully designed one and two-bedroom apartment homes tailored to your lifestyle. Enjoy stunning views and modern amenities. Browse our available options today and find the perfect space to call home in this vibrant community. Your ideal haven awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Make Yourself At Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.cta_banner_headline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Live your best life at <span data-type=\"field-token\" data-field=\"property_name\"></span>.</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>A STILL-SHOT OF YOUR NEW LIFE</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome To Overlook at Flanders</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Find your space</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Find your space.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover Mount Olive</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Perfect location</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Furry friends welcome</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Because pets are family too.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.feature_1_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet spa</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.feature_2_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dog park</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.feature_3_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet-friendly restaurants</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet policy</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Privacy Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the Joy of Living in Your Dream Apartment</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>ACCESS YOUR RESIDENT PORTAL</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Resident Login</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentreview.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents say</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>In their own words</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Hear it from our residents.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>your perfect apartment is here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule a Tour</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Sitemap</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "socialfeedsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Follow us on social media</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>360° views right here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tours</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "amenities-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>THE CONVENIENCE OF HOME</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.select_units_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "*In Select Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-chatbot.position_side": {
    "overrideType": "VALUE",
    "customValue": "left",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/apartments-fitness-center-new-brunswick-nj::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore apartments in your area</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/apartments-fitness-center-new-brunswick-nj::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Hyperlocal Page Title</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicycallout.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Our Pet Policy</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form_block": {
    "overrideType": "VALUE",
    "customValue": "elise-schedule-tour-iframe",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Overlook at Flanders in Flanders, NJ, elevate your living experience with thoughtfully designed one and two-bedroom apartments. Enjoy features like a vibrant clubhouse, outdoor lounges, and a fitness center, all while embracing a pet-friendly atmosphere. Dive into resident activities and rejuvenate by the pool—your perfect oasis awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiesforyou.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Overlook at Flanders, where comfort meets convenience in Flanders, NJ. Our thoughtfully designed one- and two-bedroom apartments boast modern amenities, including a sparkling swimming pool, fitness center, and inviting pet-friendly spaces. Embrace a lifestyle enriched with engaging resident activities and exceptional on-site services. Your new home awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step into Overlook at Flanders, where modern living meets community spirit in Flanders, NJ. Choose from stylish one and two-bedroom floor plans, and enjoy top-notch amenities like a swimming pool, fitness center, and pet-friendly spaces. Embrace convenience and comfort—secure your new home online today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Overlook at Flanders in scenic Flanders, NJ, where modern living meets comfort. Our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle needs. Ready to find your perfect home? Reach out to our leasing team today with any questions you may have!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.administrative_fee": {
    "overrideType": "VALUE",
    "customValue": "$100",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.application_fee": {
    "overrideType": "VALUE",
    "customValue": "$50",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.community_amenity_fee": {
    "overrideType": "VALUE",
    "customValue": "$400",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.month_to_month_fee": {
    "overrideType": "VALUE",
    "customValue": "$350",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.occupancy_fee": {
    "overrideType": "VALUE",
    "customValue": "$95",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.pet_fee": {
    "overrideType": "VALUE",
    "customValue": "$350",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.pet_rent": {
    "overrideType": "VALUE",
    "customValue": "$50",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.reservation_fee": {
    "overrideType": "VALUE",
    "customValue": "$200",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.security_deposit": {
    "overrideType": "VALUE",
    "customValue": "$750",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.utility_admin_billing_fee": {
    "overrideType": "VALUE",
    "customValue": "$4.53",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.utility_electric": {
    "overrideType": "VALUE",
    "customValue": "Usage-Based (Utilities)",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.utility_gas": {
    "overrideType": "VALUE",
    "customValue": "Usage-Based (Utilities)",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.utility_water_sewer": {
    "overrideType": "VALUE",
    "customValue": "Usage-Based (Utilities)",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Overlook at Flanders in Flanders, NJ, find your ideal sanctuary among our thoughtfully designed one and two-bedroom floor plans. Each layout harmonizes comfort and style, catering to your unique lifestyle. Browse our available apartment homes today—your perfect living space awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Overlook at Flanders in Flanders, NJ, vibrant living meets tranquil comfort. Our stunning photo gallery captures spacious one and two-bedroom apartments equipped with modern amenities. Enjoy recreational activities, a pet-friendly environment, and serene outdoor lounges. Picture your future here amidst luxury and community—your new home awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1 - 2 Bedroom Apartments in Flanders , NJ</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Overlook at Flanders, your serene sanctuary in Flanders, NJ. Nestled near scenic parks like Flanders Park and Lake Hopatcong, our vibrant community is just moments away from enriching local gems such as the Morris Museum and the historic Stickley Museum. Find your ideal one or two-bedroom retreat today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><span>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.&nbsp;</span></p><p><span>We collect information from visitors on our Web site through online requests including:</span></p><p><span>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.&nbsp;</span></p><p><span>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. n addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.&nbsp;</span></p><p><span>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.&nbsp;</span></p><p><span>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.&nbsp;</span></p><p><span>From time to time, we may send a “cookie” to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer’s hard drive. A cookie can’t read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.&nbsp;</span></p><p><span>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.&nbsp;</span></p><p><span>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.&nbsp;</span></p><p><span>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.&nbsp;</span></p><p><span>We collect information from visitors on our Web site through online requests including:</span></p><p><span>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.&nbsp;</span></p><p><span>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. n addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.&nbsp;</span></p><p><span>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.&nbsp;</span></p><p><span>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.&nbsp;</span></p><p><span>From time to time, we may send a “cookie” to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer’s hard drive. A cookie can’t read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.&nbsp;</span></p><p><span>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.&nbsp;</span></p><p><span>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.&nbsp;</span></p><p><span>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Imagine the culinary masterpieces you'll create in your stunning kitchen. The contentment you'll feel as you stroll the park-like grounds. Or the sense of wonder you'll experience with every sunset you view from your balcony. Add to that the lure of having a world of sightseeing and recreational opportunities within a few minutes' drive and it's clear: The Overlook at Flanders is for you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Overlook at Flanders, where comfort meets convenience in Mount Olive, NJ. Choose from our stylish one and two-bedroom apartments designed for modern living. Log in to our resident portal to effortlessly manage your rent, request maintenance, and enhance your home experience with just a few clicks!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Overlook at Flanders in serene Mount Olive, NJ, choose from stylish one and two-bedroom floor plans designed for modern living. Schedule a tour today, and join a community where comfort meets convenience. Don’t just take our word for it—see what our residents love about their home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank you for reaching out to Overlook at Flanders in Flanders, NJ! Our stylish one- and two-bedroom floor plans offer the perfect blend of comfort and modern living. A team member will connect with you soon to help you find your new home in our vibrant community!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Overlook at Flanders in beautiful Flanders, NJ! Our varied floor plans, featuring both one and two-bedroom options, are designed for comfort and style. Immerse yourself in our inviting community—take a virtual tour today and envision your new home!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "apply-now-hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      },
      "label": {
        "type": "VALUE",
        "customValue": "Apply Now"
      }
    }
  },
  "floorplanslist.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.cta_secondary_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule a Tour"
      }
    }
  },
  "footer.emergency_badge": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a159e7-a80b-77ee-97d6-e8506cb14dfb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "2-1-1 New Jersey logo"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Find Your New Home"
      }
    }
  },
  "propertyoverview.cta_secondary": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Find Your New Home"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      }
    }
  },
  "amenitiesforyou.amenity_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Swimming Pool with Sundeck"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a140c1-746f-7548-bb3c-058f880c7811.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Curving swimming pool with lounge chairs and umbrellas under a bright blue sky."
      }
    }
  },
  "amenitiesforyou.amenity_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Pet Wash"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a140c1-c0b7-766b-95c2-7a791a559f14.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Pet grooming station with tub and grooming table"
      }
    }
  },
  "amenitiesforyou.amenity_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Fitness Center"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a140c1-e683-7694-b15f-d031cde09b55.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with cardio machines, weight machines, and free weights."
      }
    }
  },
  "amenitiesforyou.amenity_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Resident Clubhouse & Lounge"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a140c1-89fb-70b9-914b-0eb45ab28fc1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern lounge area with a large sectional sofa, coffee table, fireplace, and artwork."
      }
    }
  },
  "amenitieslist.in_home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019fd957-0939-7507-a596-e84b7f970437.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Renovated apartment kitchen with stainless steel appliances, granite countertops, and white cabinets."
      }
    }
  },
  "amenitieslist.indoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019fd957-1eb0-748b-acac-3bca9880b0b2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Indoor fitness center with weight machines, benches, dumbbells, and exercise balls."
      }
    }
  },
  "amenitieslist.indoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d026b-058d-76ff-b419-f10068bf6ba4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Clubhouse resident lounge with white built-in shelving, wall-mounted TV, beige sofa, and white chairs."
      }
    }
  },
  "amenitieslist.indoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d026a-86d2-7412-a82f-106b61315ddf.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Communal recreation room with a billiards table, white cabinets, built-in shelves, and a seating area."
      }
    }
  },
  "amenitieslist.indoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d026a-6ff4-7014-b193-bea2a6baa161.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Well-equipped apartment fitness center with weight machines, benches, and exercise balls."
      }
    }
  },
  "amenitieslist.inHomePhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d026a-deff-700b-86ea-4f1060572225.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment kitchen with white cabinets, stainless steel appliances, granite countertops, and a window over the sink."
      }
    }
  },
  "amenitieslist.inHomePhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d026a-eb2c-72d4-8045-31cba67aab46.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom interior with a large wooden bed, two nightstands, lamps, plants, and a window."
      }
    }
  },
  "amenitieslist.inHomePhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d026a-f7e3-765b-a0ef-66f347b12347.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room of an apartment with a fireplace, gray walls, blue sofas, and a dining area in the background."
      }
    }
  },
  "amenitieslist.neighborhood_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019fd957-415c-7174-8cf5-89a94078f6cb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a multifamily property surrounded by lush green trees."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d026a-fdd2-76ce-a331-23308f5b589a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a two-story apartment building with a manicured lawn and a stone entry sign."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d026a-fc83-701a-9491-4f9b784da5ab.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Covered balcony with white railings, a couple of chairs, and a view of trees."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d026b-29de-76cc-a476-2c28d380d26c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a brick apartment building with attached garages, green lawn, and trees in the background."
      }
    }
  },
  "amenitieslist.outdoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a140c1-746f-7548-bb3c-058f880c7811.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Curving swimming pool with lounge chairs and umbrellas under a bright blue sky."
      }
    }
  },
  "amenitieslist.outdoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d026b-13b1-716e-8c55-31d61006cfea.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor apartment community pool with lounge chairs, red umbrellas, and a white pergola."
      }
    }
  },
  "amenitieslist.outdoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d026b-12d5-74f6-9cd8-ad52ec8da948.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two-story gray apartment building with large arched windows and a circular patio with a fire pit."
      }
    }
  },
  "amenitieslist.outdoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d026b-1c6b-7434-9dc5-7284bd68dbe7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two outdoor gas grills on a concrete pad with landscaped shrubs and a stone wall behind."
      }
    }
  },
  "feesheet.admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Admin Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$100"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.amenity": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Amenity Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$400"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.amenity_renewal": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Amenity Renewal"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Annual"
      }
    }
  },
  "feesheet.application": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Application Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.buyout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Buy-Out Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "2 Months' Rent"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.certificate": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Certificate of Occupancy"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$95"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.electric": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Electric"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.gas": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Gas"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.late": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Late Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "10%"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.lockout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Lockout Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.month_to_month": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Month To Month"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.nsf": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "NSF Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.pet_fee": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Per pet. Max 2."
      }
    }
  },
  "feesheet.pet_rent": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Per pet. Max 2."
      }
    }
  },
  "feesheet.reservation": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reservation Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.security": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Security Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$750*"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Deposit amount applies with approved credit and may be higher for conditional approvals"
      }
    }
  },
  "feesheet.transfer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Transfer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$500"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.trash": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Trash Service"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$30"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility Admin / Billing"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$4.66"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_setup": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility New Account"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.water": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Water & Sewer"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "floorplanslist.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[14].image"
      }
    }
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[26].image"
      }
    }
  },
  "hero.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "heading": {
        "type": "VALUE",
        "customValue": "COOL Amenities"
      },
      "text": {
        "type": "VALUE",
        "customValue": "Discover how our community makes life convenient and fun."
      },
      "url": {
        "type": "VALUE",
        "customValue": "/amenities"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  },
  "hero.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "heading": {
        "type": "VALUE",
        "customValue": "LUXURY HOMES"
      },
      "text": {
        "type": "VALUE",
        "customValue": "Spaces designed for comfort, focus, and everyday living."
      },
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  },
  "hero.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "heading": {
        "type": "VALUE",
        "customValue": "APPLY"
      },
      "text": {
        "type": "VALUE",
        "customValue": "Fill out the contact form and be one step closer to applying."
      },
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  },
  "neighborhoodhighlights.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-2f70-777b-8fb3-93630272bec7.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Budd Lake Diner"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Cafe & Breakfast"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "1.6"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Upbeat local diner serving all-day breakfast, hearty burgers and thick milkshakes — a easy morning go-to just minutes from home."
      }
    }
  },
  "neighborhoodhighlights.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-456c-737d-bf66-cef6faffc018.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "T.J. Maxx"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Shopping & Retail"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "2.0"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Browse ever-changing racks of brand-name apparel, shoes, accessories and housewares at this local favorite for a great daytime find."
      }
    }
  },
  "neighborhoodhighlights.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-74d2-766c-b88c-13b267f245b7.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Turkey Brook Park"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Parks & Recreation"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "1.5"
      },
      "description": {
        "type": "VALUE",
        "customValue": "267 acres of trails, ballfields, picnic pavilions and a two-acre dog park — a perfect spot to spend a sunny afternoon outdoors."
      }
    }
  },
  "neighborhoodhighlights.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-21a7-71eb-85bf-11eae826e2f1.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Market Tavern Restaurant & Bar"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Dining"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "1.5"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Relaxed spot for steaks, burgers, wings and seafood — an easygoing choice for a midday bite or weekend lunch with friends."
      }
    }
  },
  "neighborhoodhighlights.day_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-5713-77e8-a084-db5d37eca076.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Morris Museum"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Arts & Culture"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "18.0"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Rotating cultural exhibits, a planetarium and live theatrical performances make this Morristown-area museum a rewarding daytime stop for art and history lovers."
      }
    }
  },
  "neighborhoodhighlights.day_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-7b21-74be-8b09-b488dcc3d117.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Schooley's Mountain Park Main Entrance"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Trails & Recreation"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "6.5"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Wooded hiking trails, a scenic lake and open recreation grounds — an ideal spot to hike, run or spend an active afternoon in the fresh air."
      }
    }
  },
  "neighborhoodhighlights.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-35c4-721e-a366-aa57686922fd.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Tavern On the Rocks"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Bar & Nightlife"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "2.4"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Cozy neighborhood watering hole pouring eight beers on tap alongside burgers, wings and other pub eats — an easy after-work hangout."
      }
    }
  },
  "neighborhoodhighlights.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-36e5-737f-9e8d-4bd848ab0fea.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "THE BARN"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Live Music & Entertainment"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "3.5"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Lively late-night venue with live bands, eclectic American fare, a full bar and a patio — the place to catch music after dark."
      }
    }
  },
  "neighborhoodhighlights.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-3176-72ed-8aa2-f97ae90c49bc.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Caffè NaVona"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Fine Dining"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "9.5"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Regional Italian dishes and fine wines in a cozy, elegant setting, complete with a lounge for live jazz and piano — an ideal evening out."
      }
    }
  },
  "neighborhoodhighlights.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-2edd-76cb-9c36-d1c2183d7156.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Mount Olive Ginza"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Late-Night Dining"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "1.0"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Relaxed neighborhood spot for Japanese dishes, sushi rolls and Chinese favorites — a satisfying late-evening bite right around the corner."
      }
    }
  },
  "neighborhoodhighlights.night_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-5eb9-7679-8da1-5f927f801f94.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "AMC Rockaway 16"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Cinema & Entertainment"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "11.0"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Catch the latest releases in IMAX or Dolby Cinema with comfortable recliner seating at this Rockaway Townsquare multiplex — a go-to for a night at the movies."
      }
    }
  },
  "neighborhoodhighlights.night_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-21a6-74cf-8ec5-19a02154f5a2.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "The After Char-Broil Grill & Ice Cream"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Dessert & Late-Night Eats"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "2.5"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Char-broiled burgers and hand-scooped ice cream at a laid-back local grill — the perfect sweet finish to an evening or an after-hours craving."
      }
    }
  },
  "propertyoverview.image_hero": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d026a-f7e3-765b-a0ef-66f347b12347.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room of an apartment with a fireplace, gray walls, blue sofas, and a dining area in the background."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "photogallery.images": {
    "limit": null,
    "hiddenIds": [
      "custom_6b3aad4a-40b6-4204-9d09-99f97c277ae4",
      "custom_84430fc2-55f7-4813-94a0-f322907b32e2",
      "custom_5c477477-be9e-420b-9ad1-20c942e2acf6"
    ],
    "orderedIds": [
      "custom_b0000775-e5c9-4985-8a9c-3583ba9d3f7e",
      "custom_0db81e04-392f-437d-9a80-f61006440e89",
      "custom_585b1353-7357-4922-a319-9e4a9a891082",
      "custom_fc5d76de-5d3b-4c26-b926-e4aba4fd5ff6",
      "custom_4f0eca77-eb36-4659-b4e6-24e1b6ba8ee2",
      "custom_b5a72428-8b5c-4522-af4b-d37632050f85",
      "custom_f00278a7-984a-4751-9c40-d34b483ab98e",
      "custom_570308ac-789c-4b76-97b9-fa7d6eab102b",
      "custom_f02169c8-1cb6-49a8-9076-58fc7ae12733",
      "custom_c6eeacf0-d1e1-4512-a9fe-fa13516513e8",
      "custom_0279afcc-5510-4f1e-a607-c919a6f427a1",
      "custom_0cd7e78c-3bda-407b-b28a-74ace0416686",
      "custom_7df1d8d3-d2af-4595-851d-be18f1784b54",
      "custom_d2c9fe53-ff37-450c-91ad-6f799e7d3d20",
      "custom_7447cad7-8d50-437b-a129-e3db618de178",
      "custom_94fec900-8ba4-439a-a662-be95cfa9db21",
      "custom_0552a1cf-129e-48ee-8e59-1494c944b377",
      "custom_9ffc6df6-2972-49a7-bdb4-dc150ac3be02",
      "custom_c56d647c-178d-4cf7-9dd3-0678a42737fe",
      "custom_99d55dbd-234b-41b4-b89b-fe531152c9ce",
      "custom_d824c837-0da9-4bdf-ace6-7e33c59e751c",
      "custom_017f17a5-091a-49e8-b018-7d51a562b198",
      "custom_c0e0a818-8ead-4732-8be9-e527a919fe81",
      "custom_4c234003-b605-4b58-82cc-4bb4ddc87916",
      "custom_299270b7-df66-46eb-8563-4e543dc3a8cc",
      "custom_6a08cdf6-f544-4cef-b711-5b244d5ecbd2",
      "custom_24a41c11-35c2-4932-80b1-febadff7e6ef",
      "custom_3f0a398f-2337-4b1f-92c8-059f3d2b6b28",
      "custom_7ba7069a-4264-4142-86fc-6b478de4227d",
      "custom_74c9527b-ff22-4378-97d2-01483f3f22be",
      "custom_5c477477-be9e-420b-9ad1-20c942e2acf6",
      "custom_38dab5d6-b8c7-41c1-b888-7f54cdae04fc",
      "custom_6c0839e6-296d-48d9-8366-22db0527f33e",
      "custom_8bb586b8-8420-4280-afd7-d1a5bc18fe93",
      "custom_6b3aad4a-40b6-4204-9d09-99f97c277ae4",
      "custom_e6764673-ce1d-42d6-a579-96e24739efd5",
      "custom_50a53bd5-a5e6-4a90-847a-3571be37e38b",
      "custom_f8e4a46e-b121-41d6-a823-102b679762cb",
      "custom_fc41ad27-b77b-4753-9e93-cd4839b69640",
      "custom_56437d2c-42c5-4ca7-98e4-39a817cb18c7",
      "custom_3053c353-0c0e-461d-b081-16353518fa5c",
      "custom_84430fc2-55f7-4813-94a0-f322907b32e2"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_template:hyperlocal::_section.block:apartment-sync": {
    "properties": {
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "_section.InteractiveMapSection": {
    "properties": {
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "_section.PetPolicyCallout": {
    "properties": {
      "paddingTop": "0px"
    }
  },
  "header.address_link": {
    "properties": {
      "paddingTop": "5px"
    }
  }
};
